module.exports = __webpack_public_path__ + "img/ico-arc.8084f68d.svg";